import { AuthenticationProvider } from '@/common/contexts/authentication/AuthenticationContext';
import PublicLayout from '@/common/pages/(public)/_layout';
import { PortalHost } from '@rn-primitives/portal';

export default function Layout() {
  return (
    <AuthenticationProvider>
      <PublicLayout />
      <PortalHost name="overlay" />
    </AuthenticationProvider>
  );
}
